export const OemRateWindowUnit = {
  DAY: 'day',
  HOUR: 'hour',
} as const;

export type OemRateWindowUnit =
  (typeof OemRateWindowUnit)[keyof typeof OemRateWindowUnit];
